import React, { useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalEditMobile } from '../../../../redux/actions/partials/modals/modalEditMobile';
import { handleChangeDataModalEditMobileWarning } from '../../../../redux/actions/partials/modals/modalEditMobileWarning';
import { handleChangeDataModalEditMobileVerifyOne } from '../../../../redux/actions/partials/modals/modalEditMobileVerifyOne';
import useOutsideClick from './hooks/useOutsideClick'; 


const ModalEditMobile = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive, mobile, mobileErr} = useSelector(state => state.modalEditMobile);
	const { profile } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);


	const handleClose = () => {
		dispatch(handleChangeDataModalEditMobile('mobile', ''));
		dispatch(handleChangeDataModalEditMobile('mobileErr', ''));

		dispatch(handleChangeDataModalEditMobile('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalEditMobile('isOpen', false));
        }, 250);
    };    
    

  	const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalEditMobile]);


    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalEditMobile(name, convertPersianArabicNumbersToEnglish(value)));
    };

    const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	const convertPersianArabicNumbersToEnglish = (str) => {
 		let persianArabicNumbers = {
	        '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
	        '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
	        '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
	        '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
	    };

	    return str.replace(/[۰-۹٠-٩]/g, (char) => persianArabicNumbers[char] || char);
 	};

	// const inputRefs = useRef({});
	// const handleOnInputFocus = (key) => {
 //        const currentInput = inputRefs.current[key];
 //        if (currentInput && errorTxt.length === 0) {
 //            dispatch(handleChangeInputLoginPage('inputClass', 'input-focused'));
 //            currentInput.classList.add("input-focused");
 //        }
 //    };



    const handleSubmitForm = (event) => {
    	event.preventDefault();

    	if(! isBackdropLoading) {
	    	if(mobile.length === 0)
	    		dispatch(handleChangeDataModalEditMobile('mobileErr', 'لطفا این قسمت را خالی نگذارید!'));
	    	else if(mobile.length > 0 && mobile.length !== 11)
	    		dispatch(handleChangeDataModalEditMobile('mobileErr', 'موبایل باید 11 رقم باشد'));
	    	else if( convertPersianArabicNumbersToEnglish(mobile) === profile.mobile ) {
	    		
	    	}
	    	else {
	    		dispatch(handleChangeDataModalEditMobileVerifyOne('newMobile', convertPersianArabicNumbersToEnglish(mobile)));

	    		dispatch(handleChangeDataModalEditMobile('mobileErr', ''));

	    		dispatch(handleChangeDataModalEditMobileWarning('isOpen', true));
				setTimeout(() => dispatch(handleChangeDataModalEditMobileWarning('isActive', true)), 250);

	    		handleClose();
	    	}
    	}
    };

    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: '11'}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open bg-neutral-000 absolute overflow-y-hidden rounded-medium styles_Modal__TsaRp" tabIndex="-1" role="dialog" aria-modal="true" style={ !isMobile ? {width: '460px'} : {width: '100%', maxHeight: '100vh', height: '100%'} }>
				<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '59px'}}>
					<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width="420" height="58.59375">
						<div className="flex items-center border-complete-b-200">
							<div className="break-words py-3 grow">
								<div className="flex items-center grow">
									<p className="grow text-h5 text-neutral-900">
										<span className="relative">ویرایش شماره موبایل
										</span>
									</p>
								</div>
							</div>
							<div className="grow text-h5">
							</div>
							<div className="flex cursor-pointer" onClick={handleClose}>
								<svg data-test-id="close-modal-icon-button" style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
					</div>
					<div className="grow flex flex-col overflow-y-auto">
						<div className="grow flex flex-col styles_children__hHq5Q py-4 px-5">
							<div className="pt-4">
								<form className="">
									<label className="FormComponentFrame_FormComponentFrame__PIUpy w-full FormComponentFrame_FormComponentFrame--normal__TQSOm">
										<div className="FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 Input_InputWrapper__d_4kf">
											<div className="grow text-body-3">
												<input className="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium" type="text" name="mobile" autoComplete="off" value={toPersianDigits(mobile)} onChange={handleChangeInputs} />
											</div>
											<div className="flex">
												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-success)'}}>
													<use xlinkHref="#active"></use>
												</svg>
											</div>
										</div>
										<p className="text-body-2 text-hint-text-error">{mobileErr}</p>
									</label>
								</form>
								<div className="py-2 rounded mt-3 pr-0">
									<div className="flex">
										<div className="flex mt-1">
											<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-neutral-hint)'}} >
												<use xlinkHref="#infoOutline"></use>
											</svg>
										</div>
										<span className="mr-4 text-body-1 text-neutral-500">برای ثبت این شماره باید آن را تایید کنید.</span>
									</div>
								</div>
								<div className="bg-neutral-000 w-full px-5 py-3 lg:p-0 flex flex-col lg:flex-row justify-center lg:justify-end items-center mt-4 fixed lg:relative bottom-0 left-0">
									<button onClick={handleSubmitForm} className={`relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium w-full lg:w-unset mt-2 lg:mt-0 ${profile.mobile === convertPersianArabicNumbersToEnglish(mobile) ? 'styles_btn--disabled__lljQT  pointer-events-none' : ''}`} >
										<div className="flex items-center justify-center relative grow">دریافت کد تایید و تغییر شماره
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



        
    );
}

export default ModalEditMobile;
